export const PARTNER_SOURCE = 'PARTNER_SOURCE';

export const NPAW_CUSTOM_CONSTANTS = {
  NOT_RECEIVED: 'Not-Received',
  NOT_APPLICABLE: 'Not-Applicable',
  ZEE5: 'ZEE5',
  LIVE: 'Live',
  VOD: 'VOD',
  DRM: 'DRM',
  HLS: 'HLS',
  DASH: 'DASH',
  GUEST: 'Guest',
  WEB: 'Web',
  DEFAULT_PARTNER_ZEE5: 'ZEE5',
  ORGANIC: 'Organic',
  UNKNOWN: 'Unknown',
  WIFI: 'wifi',
  PLAYER_NAME: 'ZEE5-Web App'
};

export const NPAW_ANALYTICS_OPTIONS_KEYS = {
  VERSION: 'app.releaseVersion',
  APP_NAME: 'app.name',
  EMAIL: 'user.email',
};

export const VIDEO_OPTIONS_KEYS = {
  TITLE: 'content.title',
  PLATFORM_NAME: 'device.name',
  DEVICE_CODE: 'device.code',
  CONNECTION_TYPE: 'network.connectionType',
  IS_LIVE: 'content.isLive',
  DURATION: 'content.duration',
  RENDITION: 'content.rendition',
  STREAMING_PROTOCOL: 'content.streamingProtocol',
  TV_SHOW: 'content.tvShow',
  SEASON: 'content.season',
  EPISODE_TITLE: 'content.episodeTitle',
  CHANNEL: 'content.channel',
  ID: 'content.id',
  TYPE: 'content.type',
  GENRE: 'content.genre',
  LANGUAGE: 'content.language',
  SUBTITLES: 'content.subtitles',
  CONTRACTED_RESOLUTION: 'content.contractedResolution',
  PLAYBACK_TYPE: 'content.playbackType',
  METADATA: 'content.metadata'
} as const;

